@import "../../scss";

.root {
  position: fixed;
  bottom: var(--spacer-4);
  left: var(--spacer-4);
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  background: none;
  border: none;
  text-transform: uppercase;
  color: var(--color-cream);
  cursor: pointer;
  user-select: none;
  @include typo--small-label();
  transition: opacity 0.2s ease, color 0.2s ease;

  @include media-breakpoint-down("md") {
    bottom: var(--spacer-4);
  }

  @media (max-height: 600px) {
    bottom: var(--spacer-2);
  }
}

.root svg {
  margin-right: 0.65rem;
}

.root path {
  transition: fill 0.2s ease;
}

.root--centered {
  left: 50%;
  transform: translateX(-50%);
}

.root--is-hidden {
  pointer-events: none;
  opacity: 0;
}

.root--is-green {
  color: var(--color-bright-green);

  path {
    fill: var(--color-bright-green);
  }
}
